import React, { memo } from 'react';
import { MdAccountTree, MdStore } from 'react-icons/md';
import { useDispatch, useSelector } from 'react-redux';
import { Dropdown, Tooltip, Whisper } from 'rsuite';
import { RootState } from '../../../../../@types/RootState';
import { Layout } from '../../../../../components';
import { SET_DATA_POINTS_EXHIBITION_TYPE } from '../../../../../reducers/gerenciadorPrecos/datapointExhibitionType';
import { RESET_QUICK_ACTION_FILTER } from '../../../../../reducers/gerenciadorPrecos/quickActionsFilter';
import { getCurrentPriceManagerUserKey, usePriceManagerViewStore } from '../../../../../store/priceManagerViewStore';
import { DataUltimaIntegracao } from '../DataUltimaIntegracao';
import { FixedLayoutToggleButton } from './FixedLayoutToggleButton';
import styles from './Gerenciador.module.scss';
import OfferDataToggleButton from './OfferDataToggleButton';

const GerenciadorHeader: React.FC = () => {
  const dispatch = useDispatch();
  const setPreferredView = usePriceManagerViewStore(state => state.setView);
  const datapointExhibitionType = useSelector((state: RootState) => state.datapointExhibitionType.datapointExhibitionType);
  const basicConfig = useSelector((state: RootState) => state.reducerIPA.basicConfig);
  const clusterVisionEnabled = basicConfig?.competitorsDays.pricing_preferences === 'CLUSTER';

  const isFarmaClient = basicConfig?.competitorsDays.offer_channels_config_dto?.enabled ?? false;

  const handleGroupSelect = (group: 'PRODUCT' | 'PRODUCT_CLUSTER') => {
    const isFamily = datapointExhibitionType === 'FAMILY' || datapointExhibitionType === 'PRODUCT_CLUSTER_FAMILY';
    const newType = group === 'PRODUCT' ? (isFamily ? 'FAMILY' : 'PRODUCT') : isFamily ? 'PRODUCT_CLUSTER_FAMILY' : 'PRODUCT_CLUSTER';

    setPreferredView(getCurrentPriceManagerUserKey(), newType);
    dispatch(SET_DATA_POINTS_EXHIBITION_TYPE(newType));
  };

  const handlePriceSelect = (price: 'PRODUCT' | 'FAMILY') => {
    if (price === 'FAMILY') {
      dispatch(RESET_QUICK_ACTION_FILTER());
    }
    const isCluster = datapointExhibitionType === 'PRODUCT_CLUSTER' || datapointExhibitionType === 'PRODUCT_CLUSTER_FAMILY';
    const newType = price === 'PRODUCT' ? (isCluster ? 'PRODUCT_CLUSTER' : 'PRODUCT') : isCluster ? 'PRODUCT_CLUSTER_FAMILY' : 'FAMILY';

    setPreferredView(getCurrentPriceManagerUserKey(), newType);
    dispatch(SET_DATA_POINTS_EXHIBITION_TYPE(newType));
  };

  const isProductType = datapointExhibitionType === 'PRODUCT' || datapointExhibitionType === 'PRODUCT_CLUSTER';
  const title = isProductType ? 'Produto' : 'Família';

  const groupByMap: Record<string, string> = {
    FAMILY: 'Loja',
    PRODUCT: 'Loja',
    PRODUCT_CLUSTER: 'Cluster',
    PRODUCT_CLUSTER_FAMILY: 'Cluster',
  };
  const selectedGroupBy = groupByMap[datapointExhibitionType];

  return (
    <div className={styles['gerenciador-header']}>
      <span className={styles['gerenciador-header__content']}>
        <Layout.Title>Gerenciador de preços</Layout.Title>
        <DataUltimaIntegracao />
      </span>

      <span className={styles['gerenciador-header__action-container']}>
        <FixedLayoutToggleButton />
        {isFarmaClient && <OfferDataToggleButton />}

        {clusterVisionEnabled && (
          <Whisper placement="top" speaker={<Tooltip>Agrupar por</Tooltip>}>
            <Dropdown title={selectedGroupBy} icon={<MdStore className={styles['gerenciador-header__icon']} />}>
              <Dropdown.Item className={styles['gerenciador-header__item']} id="group-by-store" onSelect={() => handleGroupSelect('PRODUCT')}>
                Loja
              </Dropdown.Item>
              <Dropdown.Item className={styles['gerenciador-header__item']} id="group-by-cluster" onSelect={() => handleGroupSelect('PRODUCT_CLUSTER')}>
                Cluster de lojas
              </Dropdown.Item>
            </Dropdown>
          </Whisper>
        )}
        <Whisper placement="bottom" speaker={<Tooltip>Precificar por</Tooltip>}>
          <Dropdown title={title} icon={<MdAccountTree className={styles['gerenciador-header__icon']} />}>
            <Dropdown.Item className={styles['gerenciador-header__item']} id="price-by-product" onSelect={() => handlePriceSelect('PRODUCT')}>
              Produto
            </Dropdown.Item>
            <Dropdown.Item className={styles['gerenciador-header__item']} id="price-by-family" onSelect={() => handlePriceSelect('FAMILY')}>
              Família
            </Dropdown.Item>
          </Dropdown>
        </Whisper>
      </span>
    </div>
  );
};

export default memo(GerenciadorHeader);
